import { getCurrentGameTimestamp } from '../config/dateTimeConfig';

const STORAGE_PREFIX = 'wsle:startOverlayDismissed';

/**
 * Get the localStorage key for tracking overlay dismissal per category and game date
 */
export const getStartOverlayStorageKey = (categorySlug: string): string => {
  const gameDate = getCurrentGameTimestamp();
  return `${STORAGE_PREFIX}:${categorySlug}:${gameDate}`;
};

/**
 * Check if the start overlay has been dismissed for the given category today
 */
export const isStartOverlayDismissed = (categorySlug: string): boolean => {
  const key = getStartOverlayStorageKey(categorySlug);
  return localStorage.getItem(key) === 'true';
};

/**
 * Mark the start overlay as dismissed for the given category today
 */
export const setStartOverlayDismissed = (categorySlug: string): void => {
  const key = getStartOverlayStorageKey(categorySlug);
  localStorage.setItem(key, 'true');
};

/**
 * Clear the start overlay dismissal for the given category today,
 * so the overlay will show again.
 */
export const clearStartOverlayDismissed = (categorySlug: string): void => {
  const key = getStartOverlayStorageKey(categorySlug);
  localStorage.removeItem(key);
};
